import { render, staticRenderFns } from "./provenance.vue?vue&type=template&id=4afeaae6&scoped=true"
import script from "./provenance.vue?vue&type=script&lang=js"
export * from "./provenance.vue?vue&type=script&lang=js"
import style0 from "./provenance.vue?vue&type=style&index=0&id=4afeaae6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afeaae6",
  null
  
)

export default component.exports